const imageCropper = ({
  width,
  height,
  img,
  sx,
  sy,
  swidth,
  sheight,
  imageQuality,
  filename,
  extension
}) => {
  if (!width || !height || !img || !imageQuality || !filename || !extension) {
    console.log("input error");
    console.error("input error");
    return null;
  }

  let mode;
  if (
    typeof sx === "undefined" &&
    typeof sy === "undefined" &&
    typeof swidth === "undefined" &&
    typeof sheight === "undefined"
  ) {
    mode = "resize";
  } else if (
    typeof sx !== "undefined" &&
    typeof sy !== "undefined" &&
    typeof swidth !== "undefined" &&
    typeof sheight !== "undefined"
  ) {
    mode = "crop";
  } else {
    console.log("error");
    console.error("error");
    return null;
  }

  let mimeType;
  switch (extension) {
    case "jpg":
      mimeType = "image/jpeg";
      break;
    case "png":
      mimeType = "image/png";
      break;
    default:
      console.log("extension error");
      console.error("extension error");
      return null;
  }

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");

  if (mode === "crop") {
    ctx.drawImage(img, sx, sy, swidth, sheight, 0, 0, width, height);
  } else if (mode === "resize") {
    ctx.drawImage(img, 0, 0, width, height);
  }

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      file => {
        file.name = `${filename}.${extension}`;
        resolve(file);
      },
      mimeType,
      imageQuality
    );
  });
};

export default imageCropper;
